export function toIsoDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const day = String(date.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function addDays(date, amount) {
  const next = new Date(date)
  next.setDate(next.getDate() + amount)
  return next
}

export function addMonths(date, amount) {
  return new Date(date.getFullYear(), date.getMonth() + amount, 1)
}

export function weekdayLabels() {
  const base = new Date(2024, 0, 1)
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(base)
    day.setDate(base.getDate() + index)
    return day.toLocaleDateString(undefined, { weekday: "short" })
  })
}

export function calendarDays(year, month) {
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)
  const startOffset = (firstDay.getDay() + 6) % 7
  const days = []

  for (let i = 0; i < startOffset; i += 1) days.push(null)

  for (let day = 1; day <= lastDay.getDate(); day += 1) {
    days.push(new Date(year, month, day))
  }

  return days
}

export function formatDisplayDate(isoDate) {
  try {
    const date = new Date(`${isoDate}T12:00:00`)
    return date.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })
  } catch {
    return isoDate
  }
}

export function formatDisplayTime(value) {
  if (!value) return ""
  const [hour, minute] = value.split(":").map(Number)
  if (Number.isNaN(hour) || Number.isNaN(minute)) return value
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`
}
